import { render, staticRenderFns } from "./Confirmation.vue?vue&type=template&id=252b2a4a&scoped=true"
import script from "./Confirmation.vue?vue&type=script&lang=ts"
export * from "./Confirmation.vue?vue&type=script&lang=ts"
import style0 from "./Confirmation.vue?vue&type=style&index=0&id=252b2a4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252b2a4a",
  null
  
)

export default component.exports